module.exports = __webpack_public_path__ + "img/link-01.fa010552.png";